export { browserAgent } from './agent';
export { initializeBrowser } from './initializeBrowser';
export { isBrowserMonitoringEnabled } from './isBrowserMonitoringEnabled';
export { captureError } from './captureError';
export { setPageAction } from './setPageAction';
export { setCustomAttribute } from './setCustomAttribute';
export { setUser } from './setUser';
export { createBrowserLogger } from './browserLogger';
export type { BrowserLogger, BrowserLogAttributes } from './browserLoggerTypes';
export { reportThirdPartyScriptError } from './thirdPartyScriptError';
